import { render, staticRenderFns } from "./qrRegistration.vue?vue&type=template&id=2463eb74&scoped=true&"
import script from "./qrRegistration.vue?vue&type=script&lang=js&"
export * from "./qrRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2463eb74",
  null
  
)

export default component.exports